import apiV2 from "api-v2";
import { toFormData } from "axios";
import { GUESTRFQ, GUESTRFQTOTAL } from "constants/guest";
import { showToast } from "utils/helpers";
import { getGuestRFQ, saveGuestRFQ } from "utils/storageHelper";

const savingStorage = (key, payload) => {
	let guest_rfq = {
		total: "",
		data: [],
	};
	let guestRFQStorage = getGuestRFQ();
	if (guestRFQStorage) {
		guest_rfq = { ...guestRFQStorage };
		guest_rfq[key] = payload;
	} else {
		guest_rfq[key] = payload;
	}
	saveGuestRFQ(guest_rfq);
};

export const createRFQTOTAL = (payload) => {
	return async (dispatch) => {
		try {
			dispatch({ type: GUESTRFQTOTAL, payload: payload });
			savingStorage("total", payload);
		} catch (err) {
			showToast(err?.message, "Error");
		}
	};
};

export const createRFQ = (payload) => {
	return async (dispatch) => {
		try {
			dispatch({ type: GUESTRFQ, payload: payload });
			savingStorage("data", payload);
		} catch (err) {
			showToast(err?.message, "Error");
		}
	};
};

export const acceptDeclineSubmissionGuest = async (
	rfqId,
	hasAccepted,
	email,
	reason
) => {
	const data = toFormData({
		hasAccepted,
		email,
		reason,
	});
	try {
		let response = await apiV2.post(`guest/accept-or-decline/${rfqId}`, data);
		if (response.status === 200) {
			showToast(response.data.message, "Success", true);
			return response.data;
		} else {
			showToast(response.data.message, "Error");
			return false;
		}
	} catch (e) {
		return false;
	}
};
